/* eslint-disable */
// import {Bugsnag } from 'bugsnag-js';
//
// Bugsnag.apiKey = 'goawayerrors';
import Vue from 'vue';
import Polyfills from './polyfills/polyfills';

Polyfills.init();

/**
 * Polyfill for browsers without support
 */
import 'core-js/es/promise';
import 'core-js/es/object/assign';
import 'core-js/es/array/includes';
import 'core-js/es/array/from';
import 'core-js/es/map';
import 'core-js/es/set';

import VueClipboard from 'vue-clipboard2';

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
import axios from 'axios';

axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest',
};

axios.defaults.headers.common['X-CSRF-TOKEN'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

axios.interceptors.response.use((response) => {
  // Do something with response data
  return response;
}, (error) => {
  // Do something with response error
  // Should be refactored into different modules later
  if (error.response.status === 401) {
    window.location.href = '/login';
  }
  if (error.response.status === 404) {
    if (error.response.config.url.indexOf('campaigns') > -1) {
      vm.$options.router.push('/campaigns');
      return false;
    }
    if (error.response.config.url.indexOf('messages') > -1) {
      vm.$options.router.push('/messages');
      vm.$bus.$emit('displayMsg', {
        text: error.response.data.data.message,
        type: 'error',
      });
      return false;
    }
    vm.$options.router.push('/not-found');
  }
  if (error.response.status === 403 ||
      error.response.status === 500 ||
      error.response.status === 412
  ) {
    vm.$bus.$emit('displayMsg', {
      text: error.response.data.data.message,
      type: 'error',
    });
  }
  return Promise.reject(error);
});

// Handy directive for firing an event  when clicking outside element and running a bound function

Vue.directive('click-outside', {
  bind(element, binding, vnode) {
    element.clickOutsideEvent = function (event) { //  check that click was outside the el and his children
      if (!(element === event.target || element.contains(event.target))) { // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
        // binding.value(); run the arg
      }
    };
    document.body.addEventListener('click', element.clickOutsideEvent);
  },
  unbind(element) {
    document.body.removeEventListener('click', element.clickOutsideEvent);
  },
});

Vue.directive('question-builder-close', {
  bind(element, binding, vnode) {
    element.clickOutsideEvent = function (event) { //  check that click was outside the el and his children
      if (!(element === event.target || element.contains(event.target))) { // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
        // binding.value(); run the arg
      }
    };

    element.bindListener = (event) => {
      const dragStop = event.target;
      const elementClassName = element.classList.value.split(' ').map(domClass => `.${domClass}`).join('');
      // Check to see if the mouse stop is outside the config container.
      // Use case: Click inside container and ending outside - Input text selection when mouse leaves container bounds
      if (dragStop.querySelector(elementClassName) === null) {
        element.clickOutsideEvent(event);
      }

    }

    element.bindToEscapeKey = (event) => {
      if (event.code === 'Escape') {
        element.clickOutsideEvent(event);
      }
    }

    document.body.addEventListener('click', element.bindListener);
    document.body.addEventListener('keydown', element.bindToEscapeKey);

  },
  unbind(element) {
    document.body.removeEventListener('click', element.bindListener);
    document.body.removeEventListener('keydown', element.bindToEscapeKey);
  },
});


export { VueClipboard, axios };
